(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sousleau-ancient-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sl-ancient'))customElements.define('sl-ancient',class extends HTMLElement{
  connectedCallback(){
    if(this.initialized)return;this.initialized=true;
    this.querySelectorAll('[data-show]').forEach(button=>button.addEventListener('click',()=>{this.querySelectorAll('[data-visual]').forEach(panel=>panel.hidden=panel.dataset.visual!==button.dataset.show);this.querySelectorAll('[data-show]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));}));
    this.querySelectorAll('[data-dimension]').forEach(button=>button.addEventListener('click',()=>{const top=button.dataset.dimension==='top';this.querySelectorAll('[data-dimension]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));const box=this.querySelector('[data-rock-box]');box.setAttribute('y',top?'68':'108');box.setAttribute('height',top?'140':'120');const label=this.querySelector('[data-rock-dimensions]');label.textContent=label.textContent.replace(/29 × (12|14)/,top?'29 × 14':'29 × 12');}));
    const dialog=this.querySelector('dialog');this.querySelector('[data-zoom]').addEventListener('click',()=>dialog.showModal());dialog.querySelector('[data-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    const form=this.querySelector('form');const submit=form.querySelector('button[type=submit]'),label=submit.querySelector('[data-button-text]'),status=this.querySelector('[data-stone-status]');
    form.addEventListener('submit',async event=>{if(!window.SousleauCart)return;event.preventDefault();if(this.busy||submit.disabled)return;this.busy=true;const original=label.textContent;submit.disabled=true;label.textContent=this.dataset.adding;status.textContent='';status.dataset.error='false';try{await window.SousleauCart.add({id:Number(form.elements.id.value),quantity:1});status.textContent=this.dataset.success;this.querySelector('[data-cart-link]').hidden=false;}catch(error){status.textContent=error.userMessage||this.dataset.error;status.dataset.error='true';}finally{this.busy=false;submit.disabled=false;label.textContent=original;}});
    const sticky=this.querySelector('[data-stone-sticky]'),buy=this.querySelector('.sl-stone__buy');if('IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{const r=entries[0].boundingClientRect;sticky.hidden=r.bottom>0;},{threshold:0});this.observer.observe(buy);}
  }
  disconnectedCallback(){if(this.observer)this.observer.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sousleau-home-duo"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-duo-open]');
  if (!button) return;
  const panel = document.getElementById(button.getAttribute('href').slice(1));
  if (panel) panel.open = true;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sousleau-reviews-band"] && !Shopify.designMode) return;
  try {
    
class SousleauCustomerReviews extends HTMLElement {
 connectedCallback(){
  if(this.ready)return;this.ready=true;const source=JSON.parse(this.querySelector('[data-reviews-source]').textContent);const all=new DOMParser().parseFromString(String(source.all||''),'text/html');const featured=new DOMParser().parseFromString(String(source.featured||''),'text/html');const reviews=[];const ids=new Set();const text=(e,s)=>e.querySelector(s)?.textContent.trim()||'';
  for(const el of [...all.querySelectorAll('.jdgm-rev'),...featured.querySelectorAll('.jdgm-carousel-item')]){const id=el.dataset.id||el.dataset.reviewId;if(id&&ids.has(id))continue;const body=text(el,'.jdgm-rev__body')||text(el,'.jdgm-carousel-item__review-body');if(!body)continue;if(id)ids.add(id);const rating=Number(el.querySelector('.jdgm-rev__rating')?.dataset.score)||el.querySelectorAll('.jdgm-carousel-item__review-rating .jdgm--on').length;if(rating<1||rating>5)continue;reviews.push({id,body,title:text(el,'.jdgm-rev__title')||text(el,'.jdgm-carousel-item__review-title'),author:text(el,'.jdgm-rev__author')||text(el,'.jdgm-carousel-item__reviewer-name'),rating,date:el.querySelector('.jdgm-rev__timestamp')?.dataset.content||el.querySelector('.jdgm-carousel-item__timestamp')?.dataset.time||''});}
  this.track=this.querySelector('[data-review-track]');
  for(const review of reviews){const card=document.createElement('article');card.className='sl-customer-review';card.dataset.reviewId=review.id||'';const stars=document.createElement('div');stars.className='sl-customer-review__stars';stars.textContent='★'.repeat(review.rating)+'☆'.repeat(5-review.rating);stars.setAttribute('aria-label',this.dataset.rating+' '+review.rating+'/5');card.append(stars);if(review.title){const title=document.createElement('h3');title.textContent=review.title;card.append(title);}const quote=document.createElement('blockquote');quote.textContent=review.body;card.append(quote);if(review.body.length>210){const button=document.createElement('button');button.type='button';button.textContent=this.dataset.more;button.setAttribute('aria-expanded','false');button.onclick=()=>{const expanded=quote.toggleAttribute('data-expanded');button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?this.dataset.less:this.dataset.more;};card.append(button);}const author=document.createElement('div');author.className='sl-customer-review__author';const name=document.createElement('strong');name.textContent=review.author;author.append(name);const date=new Date(review.date);if(!Number.isNaN(date.getTime())){const time=document.createElement('time');time.dateTime=date.toISOString().slice(0,10);time.textContent=new Intl.DateTimeFormat(this.dataset.locale,{month:'short',year:'numeric'}).format(date);author.append(time);}card.append(author);this.track.append(card);}
  const update=()=>{const end=this.track.scrollWidth-this.track.clientWidth;this.querySelector('[data-review-direction="-1"]').disabled=this.track.scrollLeft<5;this.querySelector('[data-review-direction="1"]').disabled=this.track.scrollLeft>=end-5;};this.querySelectorAll('[data-review-direction]').forEach(b=>b.addEventListener('click',()=>this.track.scrollBy({left:Number(b.dataset.reviewDirection)*(this.track.clientWidth+18),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));this.track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(this.track);update();
 }
}
if(!customElements.get('sl-customer-reviews'))customElements.define('sl-customer-reviews',SousleauCustomerReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sousleau-showcase"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sl-showcase'))customElements.define('sl-showcase',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.busy=false;this.add=this.querySelector('[data-add]');this.status=this.querySelector('[data-status]');this.querySelectorAll('[data-variant]').forEach(select=>select.addEventListener('change',()=>{const option=select.selectedOptions[0],card=select.closest('[data-product]'),toggle=card.querySelector('[data-toggle]');card.dataset.id=option.value;card.dataset.price=option.dataset.price;card.dataset.available=option.dataset.available;card.querySelector('[data-card-price]').textContent=this.money(Number(option.dataset.price));if(option.dataset.available!=='true'){toggle.setAttribute('aria-pressed','false');toggle.textContent=toggle.dataset.select;}this.refresh();}));this.querySelectorAll('[data-toggle]').forEach(b=>b.addEventListener('click',()=>{if(this.busy||(this.chosen().length>=3&&b.getAttribute('aria-pressed')!=='true'))return;b.setAttribute('aria-pressed',b.getAttribute('aria-pressed')==='true'?'false':'true');b.textContent=b.getAttribute('aria-pressed')==='true'?b.dataset.selected:b.dataset.select;this.refresh()}));if(this.add)this.add.addEventListener('click',()=>this.submit());const timer=this.querySelector('[data-end]');if(timer){const end=Date.parse(timer.dataset.end);if(Number.isFinite(end)&&/([zZ]|[+-]\d{2}:\d{2})$/.test(timer.dataset.end)){const tick=()=>{const left=Math.max(0,Math.floor((end-Date.now())/1000));if(!left){timer.textContent=timer.dataset.ended;this.expired=true;if(this.add)this.add.disabled=true;clearInterval(this.interval);return;}const v=[Math.floor(left/86400),Math.floor(left/3600)%24,Math.floor(left/60)%60,left%60];timer.querySelectorAll('[data-unit]').forEach((e,i)=>e.textContent=String(v[i]).padStart(2,'0'));};tick();this.interval=setInterval(tick,1000);}else timer.hidden=true;}}
 disconnectedCallback(){clearInterval(this.interval);}
 money(cents){return new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency||'CAD'}).format(cents/100);}
 chosen(){return [...this.querySelectorAll('[data-product]')].filter(p=>this.dataset.mode!=='selection'||p.querySelector('[data-toggle]').getAttribute('aria-pressed')==='true');}
 refresh(){if(this.dataset.mode!=='selection'||!this.querySelector('[data-count]'))return;const a=this.chosen();this.querySelectorAll('[data-toggle]').forEach(b=>b.disabled=this.busy||b.closest('[data-product]').dataset.available!=='true'||(a.length>=3&&b.getAttribute('aria-pressed')!=='true'));this.querySelector('[data-count]').textContent=a.length;const list=this.querySelector('[data-list]');list.replaceChildren();a.forEach(p=>{const li=document.createElement('li');li.textContent=p.dataset.title;list.append(li)});this.querySelector('[data-total]').textContent=new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency||'CAD'}).format(a.reduce((s,p)=>s+Number(p.dataset.price),0)/100);this.add.disabled=this.busy||a.length<2||a.length>3;}
 async submit(){if(this.busy||this.expired)return;const a=this.chosen();if(!a.length||a.some(p=>p.dataset.available!=='true'))return;if(this.dataset.mode==='selection'&&(a.length<2||a.length>3))return;this.busy=true;this.add.disabled=true;this.querySelectorAll('[data-variant]').forEach(s=>s.disabled=true);this.refresh();this.status.textContent='';try{const group=crypto.randomUUID();await window.SousleauCart.add(a.map(p=>({id:Number(p.dataset.id),quantity:1,...(this.dataset.mode==='selection'?{properties:{_sl_selection:this.dataset.campaign,_sl_selection_group:group}}:{})}))); this.status.textContent=this.status.dataset.success;}catch(e){this.status.textContent=e.userMessage||this.status.dataset.error;}finally{this.busy=false;this.add.disabled=false;this.querySelectorAll('[data-variant]').forEach(s=>s.disabled=false);this.refresh();}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sousleau-thrive-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sl-thrive-dose'))customElements.define('sl-thrive-dose',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('input');const update=()=>{const n=input.valueAsNumber;const valid=Number.isFinite(n)&&n>0&&n<=10000;this.querySelector('output').hidden=!valid;this.querySelector('[data-invalid]').hidden=valid;input.setAttribute('aria-invalid',String(!valid));if(valid)this.querySelector('[data-dose]').textContent=new Intl.NumberFormat(document.documentElement.lang,{minimumFractionDigits:2,maximumFractionDigits:2}).format(n/18.92705892)};input.addEventListener('input',update);update()}});

  } catch(e) { console.error(e); }
})();
})();
